<template>
  <Block type="TokenLogin" id="token-login">
    <div class="token-header">
      <Title class="token-header-title">{{ languages.tokenLogin }}</Title>
      <p class="token-header-tip">{{ languages.tokenTip }}</p>
    </div>
    <div class="token-main" v-show="!loading">
      <div class="container">
        <div class="box">
          <p class="box-label">UID</p>
          <div class="box-container uid">
            <Editor
              v-model="uid"
              editorClass="uid-editor"
              class="uid-wrapper"
              type="uidEditor"
              :disable="true"
            ></Editor>
            <Button
              class="uid-copy j-copy"
              @click="copy"
              :data-clipboard-text="uid"
              >{{ languages.copy }}</Button
            >
          </div>
        </div>
        <div class="box">
          <p class="box-label">{{ languages.tokenKey }}</p>
          <div class="box-container token">
            <p class="token-container">
              <span v-for="(item, index) in token" :key="index">{{
                item
              }}</span>
            </p>
            <p class="token-refresh-time">
              {{ languages.lastRefresh }}{{ expire }}{{ languages.second }}
            </p>
            <!-- <Button class="token-refresh-btn" @click="refresh">{{
              languages.immediatelyRefresh
            }}</Button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="token-intro">
      <Title class="token-intro-title">{{ languages.tokenIntro }}</Title>
      <p class="token-intro-item">{{ languages.tokenIntro1 }}</p>
      <p class="token-intro-item">{{ languages.tokenIntro2 }}</p>
    </div>
    <PopupWindow
      v-if="visibleTipPopup"
      type="tips"
      :languages="languages"
      :content="popupTip"
      @onConfirm="visibleTipPopup = false"
    ></PopupWindow>
    <PopupWindow
      v-if="visibleErrorPopup"
      type="tips"
      :languages="languages"
      :content="popupError"
      @onConfirm="popupErrorConfirm"
    ></PopupWindow>
    <transition name="fade">
      <LoaddingPage v-show="loading"></LoaddingPage>
    </transition>
  </Block>
</template>

<script>
import Clipboard from 'clipboard';
import { GET_TOKEN } from '../../store/passport/tokenLogin';
import globalConfig from '../../utiles/globalConfig';
export default {
  name: 'TokenLogin',
  data() {
    return {
      loading: true,
      token: '',
      expire: 59,
      timer: null,
      // refreshing: false,
      visibleTipPopup: false,
      visibleErrorPopup: false,
      popupTip: '',
      popupError: ''
    };
  },
  activated() {
    this.getToken();
  },
  computed: {
    uid() {
      let userIdFromCache = localStorage.getItem('userId');
      let userIdFromParam = globalConfig.getHrefParam('userId');
      return (
        this.$store.state.account.userId || userIdFromCache || userIdFromParam
      );
    },
    languages() {
      return this.$store.state.tokenLogin.languages;
    }
  },
  methods: {
    async getToken() {
      return this.$store
        .dispatch(GET_TOKEN)
        .then(({ res }) => {
          Number(res?.result) === 1
            ? this.successGetTokenHandle(res?.data)
            : this.errorGetTokenHandle(res?.msg);
        })
        .catch(err => {
          this.errorGetTokenHandle(err);
        });
    },
    // async refresh() {
    //   if (this.refreshing) return; // 刷新中，停止执行
    //   this.refreshing = true;
    //   await this.getToken();
    //   this.refreshing = false;
    // },
    setToken(data) {
      this.token = data.TOKEN;
      this.expire = data.EXPIRE;
    },
    expireCount() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.expire--;
        if (this.expire <= 0) {
          clearInterval(this.timer);
          this.getToken();
        }
      }, 1000);
    },
    successGetTokenHandle(data) {
      this.setToken(data);
      this.expireCount();
      this.loading = false;
    },
    errorGetTokenHandle(errorTip) {
      this.showErrorPopup(errorTip);
    },
    copy() {
      const clipboard = new Clipboard('.j-copy');
      clipboard.on('success', e => {
        this.showTipPopup(this.languages.copy_success);
        e.clearSelection();
      });
      clipboard.on('error', e => {});
    },
    showTipPopup(tip) {
      this.popupTip = tip;
      this.visibleTipPopup = true;
    },
    showErrorPopup(errorTip) {
      this.popupError = errorTip;
      this.visibleErrorPopup = true;
    },
    popupErrorConfirm() {
      this.visibleErrorPopup = false;
      this.$router.back();
    }
  }
};
</script>

<style lang="scss">
$green: #57ae67;
$grey: #949494;

#token-login {
  width: 100%;
  min-height: 100%;
  background-color: #eaeaea;
}

.token-header {
  margin: auto;
  padding: 44px 32px 48px;
  &-title {
    margin-bottom: 14px;
    font-size: 28px;
    font-weight: bold;
  }
  &-tip {
    font-size: 24px;
  }
}

.token-main {
  margin: 0 auto 56px;
  padding: 0 34px;

  .container {
    box-sizing: border-box;
    padding: 34px 44px;
    background-color: #fff;
    font-size: 18px;
  }

  .box-label {
    font-size: 24px;
    margin-bottom: 24px;
  }
}

.box-container {
  text-align: center;

  &.uid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 64px;

    .uid-wrapper {
      flex: 1;
      box-sizing: border-box;
      height: 60px;
      padding: 0 18px;
      margin-right: 24px;
      border: 1px solid $green;
      border-color: $green;
      font-size: 20px;
      line-height: 60px;
      text-align: left;
    }

    .uid-copy {
      min-width: 84px;
      height: 68px;
      font-size: 24px !important;
    }
  }

  .token-container {
    overflow: auto;
    display: flex;
    justify-content: space-between;
    width: 400px;
    max-width: 100%;
    margin: 0 auto 54px;

    > span {
      width: 80px;
      height: 100px;
      border: 1px solid $green;
      font-size: 58px;
      line-height: 100px;
      text-align: center;
    }
  }

  .token-refresh-time {
    margin-bottom: 18px;
    text-align: center;
  }

  // .token-refresh-btn {
  //   width: 270px;
  //   margin: auto;
  //   font-size: 24px !important;
  // }
}

.token-intro {
  margin: auto;
  padding: 0 32px 48px;
  font-size: 18px;

  &-title {
    font-size: 28px;
    margin-bottom: 18px;
  }

  &-item {
    line-height: 28px;
    font-size: 18px;
  }
}
</style>
